import React, { Component, Suspense, useEffect, useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faCheck, faPen, faChevronCircleRight } from '@fortawesome/free-solid-svg-icons';
import { CodingEventQueueService } from '../../services';
import { useImmer } from 'use-immer';
import { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { useHistory } from 'react-router';

const CodingEventQueues = (props) => {
    const [queues, setQueues] = useImmer([]);
    const [canCreate, setCanCreate] = useState(false);

    const authContext = useContext(AuthContext); 

    const history = useHistory();

    useEffect(() => {
        const values = [authContext.claimValues.createReadUpdateDelete];
        const canCreate = authContext.hasPermission(authContext.claims.canCrudAccounts, values);
        setCanCreate(canCreate);
        getQueues();
    }, [])

    const getQueues = async () => {
        var queueService = new CodingEventQueueService();
        var callResult = await queueService.getQueues();
        if (callResult.result) {
            setQueues(callResult.model);
        } 
    }

    const createNewEventQueue = async (id, name, state) => {
        var queueService = new CodingEventQueueService();
        var result = await queueService.saveQueue(id, name, state);
        if (result.result) {
            authContext.hideModal();
            history.push({
                pathname: `/admin/codingqueues/${result.model.id}`
            })
        }
        else {
            return result;
        }
    }

    const renderCodingQueuesTable = () => {
        return (
            <table className='table table-striped table-hover' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Queue Name</th>
                        <th>Team Leads</th>
                        <th className="table-fit" />
                    </tr>
                </thead>
                <tbody>
                    {queues.map((queue) =>
                        <tr key={queue.id}>
                            <td>{queue.name}</td>
                            <td>{queue.teamLeads}</td>
                            <td className="table-fit">
                                <LinkContainer to={'codingqueues/' + queue.id}>
                                    <FontAwesomeIcon icon={faChevronCircleRight} className="secondary-icon" />
                                </LinkContainer>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    return (
        <Card>
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto" >Coding Event Queues</div>
                <div className="card-btn-group">
                    <Button
                        variant="primary"
                        style={!canCreate ? { display: "none" } : null}
                        size="sm"
                        onClick={() => authContext.showModal({
                            open: true,
                            hideModal: authContext.hideModal,
                            saveModel: createNewEventQueue
                        }, 'createCodingEventQueue')}>
                        Create
                    </Button>
                </div>
            </Card.Header>
            <Card.Body className="card-body-table">
                {renderCodingQueuesTable()}
            </Card.Body>
        </Card>
    );
}

export default CodingEventQueues;

//class CodingEventQueues extends Component {
//    constructor(props, context) {
//        super(props, context);
//        this.state = { queues: [{ codingEvents: [] }] };
//    }
//    // This method is called when the component is first added to the document
//    componentDidMount() {
//        this.ensureDataFetched();
//    }

//    async ensureDataFetched() {
//        var queueService = new CodingEventQueueService();
//        var callResult = await queueService.getQueues();
//        if (callResult.result) {
//            this.setState({ queues: callResult.model });
//        }
//    }

//    renderCodingQueuesTable() {
//        return (
//            <table className='table table-striped table-hover' aria-labelledby="tabelLabel">
//                <thead>
//                    <tr>
//                        <th>Queue Name</th>
//                        <th>Team Leads</th>
//                    <th className="table-fit"/>
//                </tr>
//                </thead>
//                <tbody>
//                {this.state.queues.map((queue) =>
//                        <tr key={queue.id}>
//                        <td>{queue.name}</td>
//                            <td>{queue.teamLeads}</td>
//                            <td className="table-fit">
//                                <LinkContainer to={'codingqueues/' + queue.id}>
//                                    <FontAwesomeIcon icon={faChevronCircleRight} className="secondary-icon" />
//                                </LinkContainer>
//                            </td>
//                        </tr>
//                    )}
//                </tbody>
//            </table>
//        );
//    }

//    render() {
//        return (
//            <Card>
//                <Card.Header className="d-flex align-items-center">
//                    <div className="mr-auto" >Coding Event Queues</div>
//                    <div className="card-btn-group">
//                        <Button variant="success" size="sm" onClick={() => createNewQueue()}>Create</Button>
//                    </div>
//                </Card.Header>
//                <Card.Body className="card-body-table">
//                    {this.renderCodingQueuesTable()}
//                </Card.Body>
//            </Card>
//        );
//    }
//}

//export default CodingEventQueues;